import { defineComponent as _defineComponent } from 'vue'
import { CompanyWhiteListIpGetResponse } from '@/interfaces/api/general/company';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';

import IpAddressTable from '@/views/pages/ipAddressRestriction/IpAddressTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'IpAddressRestrictionPageDemo',
  setup(__props) {

const m = defineMessages({
  noticeItem:
    '「IPアドレス制限オプション」を追加購入いただいたお客様がご利用になれる機能です。お求めの場合は「お問い合わせ」からご連絡ください。',
});

const dummyList: CompanyWhiteListIpGetResponse['data'] = [
  {
    id: '1',
    company_id: '1',
    ip_address: '99.99.999.991',
    name: '東京本社',
    created_at: '2024-11-11T11:11:11.000000',
    updated_at: '2024-11-11T11:11:11.000000',
  },
  {
    id: '2',
    company_id: '1',
    ip_address: '99.99.999.992',
    name: '関西支店',
    created_at: '2024-11-11T11:11:11.000000',
    updated_at: '2024-11-11T11:11:11.000000',
  },
  {
    id: '3',
    company_id: '1',
    ip_address: '99.99.999.993',
    name: '九州支店',
    created_at: '2024-11-11T11:11:11.000000',
    updated_at: '2024-11-11T11:11:11.000000',
  },
];

// eslint-disable-next-line @typescript-eslint/no-empty-function
const dummyFunction = () => {};

return { __sfc: true,m, dummyList, dummyFunction, sharedMessages, IpAddressTable }
}

})